export default "__VITE_ASSET__C535VwpH__"